import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_FEATURE_FILE_TYPES, 
    ADD_NEW_FEATURE_FILE_TYPE, 
    UPDATE_FEATURE_FILE_TYPE, 
    DELETE_FEATURE_FILE_TYPE 
} from "./actionTypes";
import {
    getFeatureFileTypesSuccess,
    getFeatureFileTypesFail,
    addFeatureFileTypeSuccess,
    addFeatureFileTypeFail,
    updateFeatureFileTypeSuccess,
    updateFeatureFileTypeFail,
    deleteFeatureFileTypeSuccess,
    deleteFeatureFileTypeFail,
   
} from "./actions"

import {
    getFeatureFileTypes,
    addNewFeatureFileType,
    updateFeatureFileType,
    deleteFeatureFileType,
   
} from "helpers/feature-file-types/feature_file_types_backend_helper";
import { toast } from "react-toastify";

function* fetchFeatureFileTypes() {
    try {
        const response = yield call(getFeatureFileTypes)

        console.log("FEATURE FILE TYPES: ", response);

        yield put(getFeatureFileTypesSuccess(response))
    } catch (error) {
        yield put(getFeatureFileTypesFail(error))
    }
}

function* onAddNewFeatureFileType({ payload }) {
    try {

        

        console.log("BEFORE SEND ON SAGA: ", payload)
        const response = yield call(addNewFeatureFileType, payload)

        console.log("RESPONSE:", response);
        yield put(addFeatureFileTypeSuccess(response.featureFileType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addFeatureFileTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateFeatureFileType({ payload: data }) {
    try {
        const response = yield call(updateFeatureFileType, data)
        yield put(updateFeatureFileTypeSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateFeatureFileTypeFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateFeatureFileType({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateFeatureFileType, payload)
        yield put(updateFeatureFileTypeSuccess(response.featureFileType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateFeatureFileTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteFeatureFileType({ payload: data }) {

    try {
        const response = yield call(deleteFeatureFileType, data)
        yield put(deleteFeatureFileTypeSuccess(response.featureFileTypeId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteFeatureFileTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* featureFileTypeSaga() {
    yield takeEvery(GET_FEATURE_FILE_TYPES, fetchFeatureFileTypes)
    yield takeEvery(ADD_NEW_FEATURE_FILE_TYPE, onAddNewFeatureFileType)
    yield takeEvery(UPDATE_FEATURE_FILE_TYPE, onUpdateFeatureFileType)
    yield takeEvery(DELETE_FEATURE_FILE_TYPE, onDeleteFeatureFileType)
}

export default featureFileTypeSaga;